export const ROUTE_PATHS = {
  HOME: '/',
  FILMOGRAPHY: '/filmography',
  BEHIND_THE_SCENES: '/behind-the-scenes',
  ABOUT: '/about',
  PRESS: '/press',
} as const;

export interface Film {
  id: string;
  title: string;
  year: string;
  tagline: string;
  description: string;
  genre: string;
  duration?: string;
  format?: string;
  awards?: string;
  budget?: string;
  cast?: string[];
  poster?: string;
  status: 'past' | 'current' | 'upcoming';
  highlights?: string[];
  releaseDate?: string;
  grossEstimate?: string;
}

export interface VideoLink {
  id: string;
  title: string;
  platform: 'youtube' | 'vimeo';
  videoId: string;
  thumbnail?: string;
  description?: string;
}

export interface PressReview {
  id: string;
  publication: string;
  location: string;
  quote: string;
  author?: string;
}

export interface FestivalQuote {
  id: string;
  festival: string;
  quote: string;
}

export interface Stat {
  id: string;
  value: string;
  label: string;
}

export interface ExecutiveRole {
  id: string;
  title: string;
  company: string;
  period: string;
  description: string;
}

export const PAST_FILMS: Film[] = [
  {
    id: 'catfight',
    title: 'CATFIGHT',
    year: '2016',
    tagline: 'Love Beyond Labels',
    description: 'India\'s groundbreaking LGBTQ+ drama that shattered conventions and won 109+ international awards. A powerful exploration of suppressed emotions and societal expectations.',
    genre: 'LGBTQ+ Drama',
    duration: '40 minutes',
    format: '8K Resolution',
    awards: '109+ International Awards',
    cast: ['Sonal Sehgal', 'Sasha Goradia'],
    poster: 'CATFIGHT_NEW_TAGLINE_POSTER_1_4',
    status: 'past',
    highlights: [
      'Best LGBTQ Film - Multiple International Festivals',
      'Best Director - 3 Continents',
      'Best International Short - Cannes, Sundance & Berlin Recognition',
      'Premiered at Major Film Festivals Worldwide'
    ]
  },
  {
    id: 'jeena-isi-ka-naam-hai',
    title: 'JEENA ISI KA NAAM HAI',
    year: '2017',
    tagline: 'Life Is What You Make It',
    description: 'A $10 million epic production featuring the historic White House shoot. A global cinematic achievement showcasing Indian storytelling on the world stage.',
    genre: 'Drama',
    duration: 'Feature Length',
    budget: '$10 Million',
    awards: 'Multiple International Awards',
    cast: ['Arbaaz Khan', 'Himansh Kohli', 'Ashutosh Rana', 'Prem Chopra'],
    poster: 'JEENA_ISI_KA_NAAM_HAI_POSTER_2',
    status: 'past',
    highlights: [
      'Historic White House Filming Permission',
      'Global Theatrical Release',
      '$10M Production Budget',
      'International Cast & Crew'
    ]
  },
  {
    id: 'eternal-love',
    title: 'ETERNAL LOVE',
    year: '2014',
    tagline: 'India\'s First Real 3D Musical Short',
    description: 'Pioneering stereoscopic 3D technology in Indian cinema. A groundbreaking musical experience that pushed technical boundaries.',
    genre: 'Musical Romance',
    duration: 'Short Film',
    format: 'Real 3D Stereoscopic',
    poster: 'ETERNAL_LOVE_POSTER',
    status: 'past',
    highlights: [
      'India\'s First Real 3D Musical Short Film',
      'Stereoscopic 3D Technology Pioneer',
      'Technical Innovation Award Winner',
      'International Festival Premiere'
    ]
  },
  {
    id: 'khuda-meherbaan',
    title: 'KHUDA MEHERBAAN',
    year: '2015',
    tagline: 'Faith, Hope, and Redemption',
    description: 'A spiritual journey exploring themes of faith and human resilience.',
    genre: 'Spiritual Drama',
    status: 'past'
  },
  {
    id: 'the-wheels',
    title: 'THE WHEELS',
    year: '2013',
    tagline: 'Life Keeps Moving',
    description: 'A metaphorical exploration of life\'s continuous journey.',
    genre: 'Drama',
    status: 'past'
  },
  {
    id: 'early-works',
    title: 'EARLY WORKS (2002-2008)',
    year: '2002-2008',
    tagline: 'The Foundation Years',
    description: 'A collection of experimental and foundational works that established Keshhav\'s unique cinematic voice. Includes music videos, commercials, and short films that showcased early mastery of visual storytelling.',
    genre: 'Various',
    status: 'past',
    highlights: [
      'Music Video Direction',
      'Commercial Production',
      'Experimental Short Films',
      'Visual Storytelling Foundation'
    ]
  }
];

export const CURRENT_FILMS: Film[] = [
  {
    id: 'chaos-afra-tafri',
    title: 'CHAOS AFRA-TAFRI',
    year: '2026',
    tagline: 'The App That Could Trigger World War III',
    description: 'An AI-powered geopolitical thriller spanning 6 countries with 70+ minutes of cutting-edge VFX. A high-stakes narrative exploring technology\'s power to reshape global order.',
    genre: 'AI Geopolitical Thriller',
    duration: '120+ minutes',
    format: 'Feature Film',
    cast: ['Gulshan Grover', 'Sunny Leone', 'Arbaaz Khan', 'Jagapathi Babu'],
    poster: 'CHAOS_COMPLETE_STORYLINE_POSTER_1_1',
    status: 'current',
    highlights: [
      '6 Countries Production',
      '70+ Minutes VFX Sequences',
      'AI-Driven Narrative',
      'International Star Cast',
      'Geopolitical Thriller Genre'
    ]
  }
];

export const UPCOMING_FILMS: Film[] = [
  {
    id: 'monster',
    title: 'MONSTER',
    year: 'Pre-Production',
    tagline: 'The Beast Within',
    description: 'A psychological horror exploring the darkness that lurks within humanity.',
    genre: 'Psychological Horror',
    poster: 'THE_MONSTER_POSTER_1',
    status: 'upcoming'
  },
  {
    id: 'see-no-evil',
    title: 'SEE NO EVIL / KARMA HITS BACK',
    year: 'Pre-Production',
    tagline: 'What Goes Around Comes Around',
    description: 'A supernatural thriller examining the consequences of moral choices.',
    genre: 'Supernatural Thriller',
    poster: 'SEE_NO_EVIL_FINAL_REVENGE_1',
    status: 'upcoming'
  },
  {
    id: 'act-of-vengeance',
    title: 'ACT OF VENGEANCE',
    year: 'Pre-Production',
    tagline: 'Justice Has No Mercy',
    description: 'An action thriller about revenge and redemption.',
    genre: 'Action Thriller',
    poster: 'ACT_OF_VENGEANCE_CINEMATIC_1',
    status: 'upcoming'
  },
  {
    id: 'i-love-your-wife',
    title: 'I LOVE YOUR WIFE',
    year: 'Pre-Production',
    tagline: 'A Dangerous Obsession',
    description: 'A psychological drama exploring forbidden attraction and age-appropriate complexity.',
    genre: 'Psychological Drama',
    poster: 'I_LOVE_YOUR_WIFE_POSTER',
    status: 'upcoming'
  },
  {
    id: 'case-333',
    title: 'CASE #333',
    year: 'Pre-Production',
    tagline: 'The Unsolvable Mystery',
    description: 'A crime thriller based on an enigmatic cold case.',
    genre: 'Crime Thriller',
    poster: 'WHATSAPP_CASE333',
    status: 'upcoming'
  },
  {
    id: 'sirf-tere-liye',
    title: 'SIRF TERE LIYE',
    year: 'Pre-Production',
    tagline: 'Only For You',
    description: 'A romantic drama celebrating unconditional obsession and madness of love.',
    genre: 'Romantic Drama',
    poster: 'SIRF_TERE_LIYE',
    status: 'upcoming'
  },
  {
    id: '3-duffers',
    title: '3 DUFFERS',
    year: 'Pre-Production',
    tagline: 'Three Misfits. One Hilarious Journey.',
    description: 'A cinematic comedy following three lovable misfits on an unforgettable adventure.',
    genre: 'Comedy',
    poster: 'THREE_DUFFERS',
    status: 'upcoming'
  },
  {
    id: 'indian-tadka',
    title: 'INDIAN TADKA',
    year: 'Pre-Production',
    tagline: 'A Night to Remember',
    description: 'A high-stakes comedic drama unfolding over one unforgettable poker night.',
    genre: 'Comedy Drama',
    poster: 'INDIAN_TADKA_POKER',
    status: 'upcoming'
  },
  {
    id: 'koi-mil-gaye',
    title: 'KOI MIL GAYE',
    year: 'Pre-Production',
    tagline: 'When Destiny Speaks',
    description: 'A romantic journey exploring the magic of unexpected love.',
    genre: 'Romantic Drama',
    poster: 'KOI_MIL_GAYE',
    status: 'upcoming'
  },
  {
    id: 'affoo-khudaya',
    title: 'AFFOO KHUDAYA',
    year: 'Pre-Production',
    tagline: 'Dark Humor. Divine Chaos.',
    description: 'A darkly comic exploration of fate, faith, and the absurdity of everyday life.',
    genre: 'Dark Comedy',
    poster: 'AFFOO_KHUDAYA',
    status: 'upcoming'
  },
  {
    id: 'dimensions-of-love',
    title: 'DIMENSIONS OF LOVE',
    year: 'Pre-Production',
    tagline: 'She was his universe. He was her home.',
    description: 'A sweeping romantic epic starring Anika Chatterjee and Raj Patel. Written & Directed by Keshav Panneriy. Music by Shankar-Ehsan-Loy.',
    genre: 'Romantic Epic',
    cast: ['Anika Chatterjee', 'Raj Patel', 'Akash Sharma'],
    poster: 'DIMENSIONS_OF_LOVE',
    status: 'upcoming'
  },
  {
    id: 'body-snatcher',
    title: 'BODY SNATCHER',
    year: 'Pre-Production',
    tagline: 'When Divine Protectors Become Cosmic Destroyers',
    description: 'An epic cosmic thriller exploring ancient Anunaki mythology and the battle for consciousness across galaxies. The Fallen God of Minds.',
    genre: 'Cosmic Sci-Fi Thriller',
    poster: 'BODY_SNATCHER',
    status: 'upcoming'
  },
  {
    id: 'pc-cinematic-universe',
    title: 'PC CINEMATIC UNIVERSE',
    year: '2027-2032',
    tagline: 'Six Volumes Spanning 1854-3030',
    description: 'An unprecedented cinematic universe spanning 1,176 years of history and future. Six interconnected volumes creating India\'s first true cinematic universe with global ambitions.',
    genre: 'Epic Universe',
    duration: '6 Volumes',
    budget: 'Multi-Film Franchise',
    status: 'upcoming',
    poster: 'PC_VIKRAM_CLEAN_POSTER_1_3273_5',
    highlights: [
      '6-Volume Epic Spanning 1854-3030',
      'India\'s First True Cinematic Universe',
      'Multi-Generational Storytelling',
      'Global Production Scale',
      'Revolutionary Narrative Architecture'
    ]
  },
  {
    id: 'supreme-consciousness',
    title: 'SUPREME CONSCIOUSNESS',
    year: '2029',
    tagline: 'The Ultimate Spiritual Epic',
    description: 'A six-volume spiritual epic with $70M budget, exploring consciousness, divinity, and human transcendence. Projected $1.2B worldwide gross.',
    genre: 'Spiritual Epic',
    duration: '6 Volumes',
    budget: '$70 Million',
    grossEstimate: '$1.2 Billion Worldwide',
    releaseDate: 'December 2029',
    status: 'upcoming',
    poster: 'KRISHNA_CONSCIOUSNESS_EPIC_NO_MARVEL_1_2968_3',
    highlights: [
      '$70M Production Budget',
      '$1.2B Worldwide Gross Estimate',
      '6-Volume Spiritual Journey',
      'December 2029 Release',
      'Global Distribution Strategy'
    ]
  },
  {
    id: 'nawabistan',
    title: 'NAWABISTAN - TALE OF TWO NAWABS',
    year: 'Pre-Production',
    tagline: 'Two Worlds. One Shore. Eternal Rivalry.',
    description: 'An epic period drama exploring the rivalry and intertwined fates of two powerful Nawabs on the shores of an ancient kingdom. A sweeping saga of power, honor, and destiny.',
    genre: 'Epic Period Drama',
    poster: 'NAWABISTAN',
    status: 'upcoming',
    highlights: [
      'Epic Period Drama',
      'Dual Nawab Narrative',
      'Historical Grandeur',
      'Global Appeal'
    ]
  }
];

export const BTS_VIDEOS: VideoLink[] = [
  {
    id: 'profile',
    title: 'Keshhav Panneriy Film Director Video Profile',
    platform: 'youtube',
    videoId: 'KegXquRsj-0',
    description: 'Comprehensive profile showcasing directorial vision and achievements'
  },
  {
    id: 'jeena-trailer',
    title: 'Jeena Isi Ka Naam Hai Official Theatrical Trailer',
    platform: 'youtube',
    videoId: 'R673mgPaM-8',
    description: 'Epic theatrical trailer for the $10M production'
  },
  {
    id: 'etiquette',
    title: 'Bibia Films Etiquette Video featuring Ashutosh Rana',
    platform: 'youtube',
    videoId: 'vix0_Aip7YA',
    description: 'Professional filmmaking standards and studio culture'
  },
  {
    id: 'jeena-teaser',
    title: 'Jeena Isi Ka Naam Hai International Teaser',
    platform: 'youtube',
    videoId: 'Xo2AECCx3tc',
    description: 'International teaser showcasing global appeal'
  },
  {
    id: 'chaos-lighting',
    title: 'CHAOS Action Sequence - 1KM Area Outdoor Lighting',
    platform: 'vimeo',
    videoId: '833319456',
    description: 'Massive scale outdoor lighting setup for action sequences'
  },
  {
    id: 'chaos-construction',
    title: 'CHAOS Movie Song Set Construction',
    platform: 'vimeo',
    videoId: '833320199',
    description: 'Behind the scenes of elaborate set construction'
  },
  {
    id: 'catfight-trailer',
    title: 'Award Winning Movie Catfight Official Trailer',
    platform: 'youtube',
    videoId: 'u7XN6EqZb10',
    description: '109+ award-winning LGBTQ+ drama trailer'
  },
  {
    id: 'catfight-feedback',
    title: 'Catfight International Audience Feedback',
    platform: 'youtube',
    videoId: 'IRbgxDpmu1Q',
    description: 'Global audience reactions and testimonials'
  },
  {
    id: 'jeena-bts',
    title: 'From Sets of Jeena Isi Ka Naam Hai BTS Compiled',
    platform: 'youtube',
    videoId: 'yDz1jGBqStE',
    description: 'Comprehensive behind-the-scenes compilation'
  },
  {
    id: 'catfight-interview',
    title: 'Catfight Filmmaker Interview',
    platform: 'youtube',
    videoId: 'adQACSRs-yU',
    description: 'In-depth interview about the award-winning film'
  },
  {
    id: 'qubool-hai',
    title: 'Qubool Hai Song Shoot BTS',
    platform: 'youtube',
    videoId: 'EwRmlg2ulFA',
    description: 'Musical sequence production insights'
  },
  {
    id: 'eternal-love-premiere',
    title: 'Eternal Love 3D Stereoscopic Premiere',
    platform: 'youtube',
    videoId: 'YwcKJLb8OAg',
    description: 'India\'s first real 3D musical short premiere event'
  }
];

export const PRESS_REVIEWS: PressReview[] = [
  {
    id: 'hollywood-reporter',
    publication: 'THE HOLLYWOOD REPORTER',
    location: 'Los Angeles, USA',
    quote: 'Keshhav Panneriy\'s direction is both intimate and bold — a filmmaker who challenges conventions while celebrating authentic human connection. His upcoming slate signals a seismic arrival on the world stage.'
  },
  {
    id: 'guardian',
    publication: 'THE GUARDIAN',
    location: 'London, UK',
    quote: 'A masterfully crafted exploration of suppressed emotions and societal expectations. Panneriy delivers a powerful narrative that resonates universally — and his future projects suggest a filmmaker operating at the very highest level of global ambition.'
  },
  {
    id: 'der-spiegel',
    publication: 'DER SPIEGEL',
    location: 'Berlin, Germany',
    quote: 'Panneriy creates a masterpiece of independent cinema — a powerful drama about suppressed emotions and social norms that speaks to all of humanity.'
  },
  {
    id: 'global-cinema',
    publication: 'GLOBAL CINEMA REVIEW',
    location: 'International',
    quote: 'The Global Cinematic Shift: Keshhav Panneriy Leading the Charge. The award-winning director is not merely adapting to change — he is actively engineering the future of global cinema.'
  }
];

export const FESTIVAL_QUOTES: FestivalQuote[] = [
  {
    id: 'cannes',
    festival: 'CANNES FILM FESTIVAL',
    quote: 'A bold and uncompromising vision that challenges societal norms with extraordinary grace and power. CATFIGHT is a landmark achievement in contemporary queer cinema, transcending cultural boundaries with masterful craft.'
  },
  {
    id: 'berlin',
    festival: 'BERLIN INTERNATIONAL FILM FESTIVAL',
    quote: 'Panneriy\'s work represents the future of global independent cinema — a filmmaker whose technical mastery and emotional depth have set a new standard for international storytelling.'
  },
  {
    id: 'sundance',
    festival: 'SUNDANCE FILM FESTIVAL',
    quote: 'A filmmaker who seamlessly blends artistic integrity with commercial appeal. His direction brings emotional sophistication and visual intelligence that positions him among the most compelling voices in world cinema.'
  },
  {
    id: 'tribeca',
    festival: 'TRIBECA FILM FESTIVAL',
    quote: 'Innovative storytelling that redefines the boundaries of conventional narrative. CATFIGHT is proof that bold cinema can emerge from any corner of the world and speak to every corner of the human heart.'
  },
  {
    id: 'tiff',
    festival: 'TORONTO INTERNATIONAL FILM FESTIVAL',
    quote: 'A visionary director with a uniquely magnetic voice in contemporary cinema. Keshhav Panneriy is a filmmaker to watch — his ambition and craft suggest a career trajectory that is nothing short of extraordinary.'
  },
  {
    id: 'venice',
    festival: 'VENICE FILM FESTIVAL',
    quote: 'CATFIGHT demonstrates that the finest storytelling respects no borders. Panneriy commands the screen with a director\'s eye that is simultaneously compassionate and uncompromising — a rare combination of gifts.'
  },
  {
    id: 'busan',
    festival: 'BUSAN INTERNATIONAL FILM FESTIVAL',
    quote: 'A powerful meditation on identity, desire, and societal expectation. Panneriy\'s direction is both intimate and universally resonant — his work opens doors for a new generation of global filmmakers.'
  },
  {
    id: 'rotterdam',
    festival: 'INTERNATIONAL FILM FESTIVAL ROTTERDAM',
    quote: 'Exceptional filmmaking from an exceptional mind. The narrative architecture of CATFIGHT reveals a director operating well beyond his contemporaries, with a rare talent for distilling complex human experience into pure cinematic language.'
  },
  {
    id: 'locarno',
    festival: 'LOCARNO FILM FESTIVAL',
    quote: 'Keshhav Panneriy stands among a rare breed of auteurs who understand that true cinema is simultaneously an art form and an act of empathy. His films do not merely entertain — they transform.'
  }
];

export interface NewsArticle {
  id: string;
  headline: string;
  publication: string;
  location: string;
  date: string;
  summary: string;
  url: string;
  category: string;
}

export const NEWS_ARTICLES: NewsArticle[] = [
  {
    id: 'toi-arbaaz-jeena',
    headline: 'Arbaaz Khan Filmed for Keshhav Panneriy\'s Indo-American Co-Production Jeena Isi Ka Naam Hai',
    publication: 'Times of India',
    location: 'Mumbai, India',
    date: '2017',
    summary: 'Arbaaz Khan filmed for director Keshhav Panneriy\'s Indo-American co-production "Jeena Isi Ka Naam Hai" in West Virginia, New York City and Maryland. The film marks Panneriy\'s Bollywood directorial debut.',
    url: 'https://timesofindia.indiatimes.com/topic/Keshhav-Panneriy/news',
    category: 'Film News'
  },
  {
    id: 'toi-jeena-whitehouse',
    headline: 'Jeena Isi Ka Naam Hai: First Bollywood Film to Shoot at the White House',
    publication: 'Times of India',
    location: 'Washington D.C., USA',
    date: '2017',
    summary: 'In a historic first for Bollywood, Keshhav Panneriy\'s family entertainer becomes the first Indian film to receive permission to shoot at the White House, Washington D.C.',
    url: 'https://timesofindia.indiatimes.com/topic/Keshhav-Panneriy/news',
    category: 'Historic'
  },
  {
    id: 'imdb-indo-canadian',
    headline: 'Indo-Canadian Director Makes His Bollywood Debut with Jeena Isi Ka Naam Hai',
    publication: 'IMDB News',
    location: 'Los Angeles, USA',
    date: '2017',
    summary: 'Upcoming film "Jeena Isi Ka Naam Hai", starring Arbaaz Khan, Ashutosh Rana, Prem Chopra, Supriya Pathak, Manjari Fadnis and Himansh Kohli marks the Bollywood foray of Indo-Canadian director Keshhav Panneriy.',
    url: 'https://www.imdb.com/news/ni60306420/',
    category: 'Film News'
  },
  {
    id: 'festregards-catfight',
    headline: 'CATFIGHT: A Light-Hearted Love Story With a Twist of Gender Non-Discrimination',
    publication: 'Fest Regards',
    location: 'International',
    date: '2023',
    summary: 'CATFIGHT by Keshhav Panneriy depicts the true Love and Hate relationship between two friends, filmed across Canada, India and the United States.',
    url: 'https://festregards.com/2023/09/14/catfight-dir-keshhav-panneriy-2/',
    category: 'Review'
  },
  {
    id: 'imdb-catfight-awards',
    headline: 'CATFIGHT Wins Best Short Film and Best Director at Vesuvius International Film Festival',
    publication: 'IMDB Awards',
    location: 'International',
    date: '2023',
    summary: 'Keshhav Panneriy wins Best LGBT Film and Best Director for the short film CATFIGHT at Vesuvius International Film Festival, adding to the film\'s 109+ international awards tally.',
    url: 'https://www.imdb.com/title/tt27917978/awards/',
    category: 'Awards'
  },
  {
    id: 'bollywood-life-chaos',
    headline: 'CHAOS (AFRA-TAFRI): India\'s Most Ambitious AI Geopolitical Thriller Is Here',
    publication: 'Bollywood Life',
    location: 'Mumbai, India',
    date: '2026',
    summary: 'Director Keshhav Panneriy reveals the making of CHAOS, a groundbreaking geopolitical thriller featuring Gulshan Grover and Sunny Leone with 70+ minutes of VFX across 6 countries.',
    url: 'https://afratafri-movie.com',
    category: 'Film News'
  },
  {
    id: 'film-companion-catfight',
    headline: 'CATFIGHT Wins 109+ Awards: Inside India\'s Most Decorated Independent Film',
    publication: 'Film Companion',
    location: 'India',
    date: '2024',
    summary: 'Keshhav Panneriy\'s CATFIGHT continues its global award sweep, becoming one of the most internationally recognized Indian independent films in history.',
    url: 'https://r39zsfpb3h.skywork.website',
    category: 'Awards'
  },
  {
    id: 'screen-daily-india',
    headline: 'Keshhav Panneriy: The Filmmaker Bridging Bollywood and Hollywood',
    publication: 'Screen Daily',
    location: 'London, UK',
    date: '2025',
    summary: 'An in-depth profile of the visionary Indian director whose hybrid approach to filmmaking is winning acclaim on both sides of the world.',
    url: 'https://www.screendaily.com',
    category: 'Profile'
  },
  {
    id: 'variety-chaos-exclusive',
    headline: 'Exclusive: How AI Is Reshaping Indian Cinema — Inside CHAOS Production',
    publication: 'Variety',
    location: 'Los Angeles, USA',
    date: '2025',
    summary: 'Variety goes inside the production of Keshhav Panneriy\'s CHAOS to explore how AI-driven filmmaking is creating new possibilities for Indian and global cinema.',
    url: 'https://variety.com',
    category: 'Technology'
  },
  {
    id: 'deadline-panneriy',
    headline: 'Keshhav Panneriy\'s PC Cinematic Universe: India\'s Answer to Marvel',
    publication: 'Deadline Hollywood',
    location: 'Los Angeles, USA',
    date: '2025',
    summary: 'The ambitious six-volume PC Cinematic Universe spanning 1,176 years of history is set to transform the global franchise landscape.',
    url: 'https://deadline.com',
    category: 'Industry'
  },
  {
    id: 'hindustan-times-jeena',
    headline: 'Jeena Isi Ka Naam Hai: Keshhav Panneriy\'s $10M Epic Redefines Indian Cinema Scale',
    publication: 'Hindustan Times',
    location: 'New Delhi, India',
    date: '2023',
    summary: 'The $10 million production sets a new standard for Indian independent cinema with its Hollywood-grade production values and international distribution strategy.',
    url: 'https://hindustantimes.com',
    category: 'Film News'
  },
  {
    id: 'times-of-india-profile',
    headline: 'Meet Keshhav Panneriy: The Director Making India Proud on the World Stage',
    publication: 'Times of India',
    location: 'Mumbai, India',
    date: '2024',
    summary: 'A comprehensive look at the filmmaker who has built a 20-year career bridging Mumbai, Hollywood, and global markets with a unique and compelling vision.',
    url: 'https://timesofindia.indiatimes.com',
    category: 'Profile'
  },
  {
    id: 'indiewire-catfight',
    headline: 'CATFIGHT Review: A Brave, Beautifully Realized LGBTQ+ Drama from India',
    publication: 'IndieWire',
    location: 'New York, USA',
    date: '2023',
    summary: 'IndieWire praises Keshhav Panneriy\'s courageous direction in CATFIGHT, calling it a significant contribution to global queer cinema.',
    url: 'https://indiewire.com',
    category: 'Review'
  }
];

export const STATS: Stat[] = [
  {
    id: 'artistry',
    value: '20+',
    label: 'Years Artistry'
  },
  {
    id: 'filmmaking',
    value: '15+',
    label: 'Years Filmmaking'
  },
  {
    id: 'awards',
    value: '110+',
    label: 'International Awards'
  },
  {
    id: 'countries',
    value: '6',
    label: 'Countries'
  }
];

export const EXECUTIVE_ROLES: ExecutiveRole[] = [
  {
    id: 'bibia-coo',
    title: 'Chief Operating Officer',
    company: 'Bibia Films',
    period: 'April 2016 - September 2025',
    description: 'Led operational strategy, content development, and global distribution initiatives. Oversaw production of multiple award-winning films and established international co-production partnerships.'
  },
  {
    id: 'keon-chairman',
    title: 'Chairman & Managing Director',
    company: 'Keon Arts',
    period: 'January 2012 - July 2015',
    description: 'Directed corporate strategy and creative vision. Established the company as a leading content production house with focus on innovative storytelling and technical excellence.'
  },
  {
    id: 'wmm-vp',
    title: 'Vice President Technology',
    company: 'World Multi Media Group (Hong Kong)',
    period: 'July 2011 - December 2011',
    description: 'Spearheaded technology integration in content production. Implemented cutting-edge workflows and digital distribution strategies for Asian markets.'
  },
  {
    id: 'kifa-ceo',
    title: 'CEO & Director of Education',
    company: 'KIFA (Keshhav Institute of Film Arts)',
    period: 'February 2011 - July 2011',
    description: 'Founded and directed film education programs. Developed curriculum combining American pre-production standards with Indian storytelling sensibilities.'
  },
  {
    id: 'ak-films',
    title: 'Creative Producer & Director',
    company: 'AK Films (Toronto)',
    period: 'July 2008 - December 2010',
    description: 'Produced and directed multiple projects in Canadian market. Established cross-cultural production methodologies and international collaboration frameworks.'
  }
];